// ClinicOS — Spanish (Colombia) translations
export const es: Record<string, string> = {
    // Navigation
    'nav.dashboard': 'Panel',
    'nav.patients': 'Pacientes',
    'nav.appointments': 'Citas',
    'nav.encounters': 'Consultas',
    'nav.telehealth': 'Teleconsulta',
    'nav.messages': 'Mensajes',
    'nav.settings': 'Configuración',
    'nav.dailyOverview': 'Vista del día',
    'nav.staff': 'Personal',
    'coordinator.subtitle': 'Panel de Coordinación',

    // Dashboard
    'dashboard.title': 'Panel de Control',
    'dashboard.today_appointments': 'Citas Hoy',
    'dashboard.total_patients': 'Pacientes Totales',
    'dashboard.pending_notes': 'Notas Pendientes',
    'dashboard.welcome': 'Bienvenido, {name}',

    // Patients
    'patients.title': 'Pacientes',
    'patients.search': 'Buscar pacientes...',
    'patients.new': 'Nuevo Paciente',
    'patients.name': 'Nombre',
    'patients.cedula': 'Cédula',
    'patients.phone': 'Teléfono',
    'patients.dob': 'Fecha de Nacimiento',
    'patients.gender': 'Género',
    'patients.gender.male': 'Masculino',
    'patients.gender.female': 'Femenino',
    'patients.gender.other': 'Otro',
    'patients.insurance': 'Seguro',
    'patients.view': 'Ver Paciente',
    'patients.no_results': 'No se encontraron pacientes',

    // Appointments
    'appointments.title': 'Citas',
    'appointments.new': 'Nueva Cita',
    'appointments.date': 'Fecha',
    'appointments.time': 'Hora',
    'appointments.doctor': 'Médico',
    'appointments.patient': 'Paciente',
    'appointments.type': 'Tipo',
    'appointments.type.in_person': 'Presencial',
    'appointments.type.telehealth': 'Teleconsulta',
    'appointments.status': 'Estado',
    'appointments.status.booked': 'Agendada',
    'appointments.status.confirmed': 'Confirmada',
    'appointments.status.arrived': 'Llegó',
    'appointments.status.in_progress': 'En Consulta',
    'appointments.status.completed': 'Completada',
    'appointments.status.cancelled': 'Cancelada',
    'appointments.reason': 'Motivo de Consulta',

    // SOAP Notes
    'soap.title': 'Nota SOAP',
    'soap.subjective': 'Subjetivo',
    'soap.objective': 'Objetivo',
    'soap.assessment': 'Evaluación',
    'soap.plan': 'Plan',
    'soap.diagnoses': 'Diagnósticos',
    'soap.medications': 'Medicamentos',
    'soap.vitals': 'Signos Vitales',
    'soap.sign': 'Firmar Nota',
    'soap.save_draft': 'Guardar Borrador',
    'soap.signed': 'Nota Firmada',
    'soap.ai_draft': 'Borrador IA',
    'soap.voice_scribe': 'Dictado por Voz',

    // Billing
    'billing.title': 'Facturación',
    'billing.invoices': 'Facturas',
    'billing.total': 'Total',
    'billing.status.draft': 'Borrador',
    'billing.status.sent': 'Enviada',
    'billing.status.paid': 'Pagada',
    'billing.status.overdue': 'Vencida',

    // Common
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.close': 'Cerrar',
    'common.loading': 'Cargando...',
    'common.confirm': 'Confirmar',
    'common.back': 'Volver',
    'common.search': 'Buscar',
    'common.filter': 'Filtrar',
    'common.actions': 'Acciones',
    'common.yes': 'Sí',
    'common.no': 'No',
    'common.coming_soon': '🚧 Próximamente',

    // Auth
    'auth.login': 'Iniciar Sesión',
    'auth.logout': 'Cerrar Sesión',
    'auth.welcome': 'Bienvenido',
};
